import { mainAPI, handleApiError } from "../api";

import {
  TotpSetupResponse,
  TotpStatusResponse,
  TotpVerificationRequest,
  TotpVerificationResponse,
  TotpSetupVerificationRequest,
} from "../types/api/totp";
import { RefreshTokenResponse } from "../types/api/auth";
import { ApiErrorResponse } from "../types/api/error";
import { getErrorMessage } from "../types/api/responseCodes";

const path = `/auth/${process.env.REACT_APP_API_VERSION}/totp`;

// Настройка TOTP - Генерация секретного ключа
export function generateTotpSetup(jwt: string) {
  return mainAPI
    .get<TotpSetupResponse>(`${path}/setup`, {
      headers: {
        // Не сохранять токен пока настройка не завершится
        Authorization: `Bearer ${jwt}`,
      },
    })
    .then(
      (res) => {
        const { secret, qrCodeBase64, provisioningUri } = res.data;
        return Promise.resolve({
          secret,
          qrCodeBase64,
          provisioningUri,
        });
      },
      (error) => handleApiError(error)
    );
}

// Настройка TOTP - Верификация TOTP-кода для завершения настройки. Подтверждает, что пользователь правильно настроил приложение-аутентификатор.
export function verifyTotpSetup(
  verificationData: TotpSetupVerificationRequest,
  jwt: string
) {
  return mainAPI
    .post<TotpVerificationResponse>(`${path}/setup`, verificationData, {
      skipErrorHandling: true,
      metadata: { addCountry: false },
      headers: {
        // Не сохранять токен пока настройка не завершится
        Authorization: `Bearer ${jwt}`,
      },
    })
    .then(
      (res) => {
        const { enabled, verifiedAt } = res.data;
        return Promise.resolve({
          enabled,
          verifiedAt,
        });
      },
      (error) => {
        const errorMessage = getErrorMessage(error);
        return Promise.reject(new Error(errorMessage));
      }
    );
}

// Настройка TOTP - Верификация TOTP-кода при входе, когда включена двухфакторная аутентификация.
export function verifyTotp(verificationData: TotpVerificationRequest) {
  return mainAPI
    .post<RefreshTokenResponse>(`${path}/verify`, verificationData, {
      skipErrorHandling: true,
      metadata: { addCountry: false },
    })
    .then(
      (res) => {
        const { accessToken, refreshToken } = res.data;
        return Promise.resolve({
          accessToken,
          refreshToken,
        });
      },
      (error) => {
        const apiError: ApiErrorResponse = error.response?.data;
        const errorMessage =
          apiError?.errors?.error || apiError?.detail || "Произошла ошибка";

        const customError: any = new Error(errorMessage);
        customError.status = error.response?.status;
        return Promise.reject(customError);
      }
    );
}

// TOTP Статус
export function getTotpStatus() {
  return mainAPI.get<TotpStatusResponse>(`${path}/status`).then(
    (res) => {
      const { enabled, verifiedAt } = res.data;
      return Promise.resolve({
        enabled,
        verifiedAt,
      });
    },
    (error) => handleApiError(error)
  );
}

// TOTP отключить
export function disableTotp() {
  return mainAPI.delete(`${path}/disable`).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => handleApiError(error)
  );
}
